module.exports = __webpack_public_path__ + "static/telefonica_white-19c82f9da9d198346e6d7490ef475b02.png";